module.exports = __webpack_public_path__ + "static/img/szafa_22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_22.svg
// module id = 6HFy
// module chunks = 0